export default "__VITE_ASSET__KLFCTokp__"